/* MERRY VELA - extras: carousel dots, cart title count, Polish UI string shim */
(function () {
  'use strict';
  function initDots() {
    document.querySelectorAll('[data-dots-track]:not([data-dots-ready])').forEach(function (track) {
      var holder = track.parentNode.querySelector('[data-dots]');
      var items = track.children;
      if (!holder || items.length < 2) return;
      track.setAttribute('data-dots-ready', 'true');
      holder.classList.add('mv-dots');
      var dots = [];
      function left(el) { return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft; }
      Array.prototype.forEach.call(items, function (el, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'mv-dot';
        d.setAttribute('aria-label', 'Pokaż slajd ' + (i + 1));
        d.addEventListener('click', function () { track.scrollTo({ left: left(el), behavior: 'smooth' }); });
        holder.appendChild(d);
        dots.push(d);
      });
      function sync() {
        var best = 0;
        var bestDist = Infinity;
        Array.prototype.forEach.call(items, function (el, i) {
          var dist = Math.abs(left(el) - track.scrollLeft);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = items.length - 1;
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === best); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      sync();
    });
  }
  var KEY = 'mv_cart_timer_end';
  var DURATION = 5 * 60 * 1000;
  var memoryEnd = 0;
  function readEnd() { try { return parseInt(window.localStorage.getItem(KEY), 10) || 0; } catch (e) { return memoryEnd; } }
  function writeEnd(v) { memoryEnd = v; try { window.localStorage.setItem(KEY, String(v)); } catch (e) {} }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var title = document.querySelector('#CartDrawer .drawer__title');
    var src = document.querySelector('#CartDrawer [data-cart-count-source]');
    if (title && src) {
      var n = parseInt(src.textContent, 10) || 0;
      var w = n === 1 ? 'produkt' : ((n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)) ? 'produkty' : 'produktów');
      title.textContent = 'Koszyk • ' + n + ' ' + w;
    }
    var els = document.querySelectorAll('[data-cart-timer]');
    if (!els.length) return;
    var end = readEnd();
    var now = Date.now();
    if (!end || end <= now) { end = now + DURATION; writeEnd(end); }
    var secs = Math.max(0, Math.round((end - now) / 1000));
    var txt = pad(Math.floor(secs / 60)) + ':' + pad(secs % 60);
    els.forEach(function (el) { el.textContent = txt; });
  }
  function start() {
    initDots();
    tick();
    window.setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', initDots);

  /* Polish shim: theme.js sets a few button/error labels in English after variant or cart changes */
  var PL = {
    'Add to Cart': 'Dodaj do koszyka',
    'Sold Out': 'Wyprzedane',
    'Unavailable': 'Niedostępny',
    'Something went wrong. Please try again.': 'Coś poszło nie tak. Spróbuj ponownie.',
    'We could not update your cart.': 'Nie udało się zaktualizować koszyka.'
  };
  function polish(root) {
    (root || document).querySelectorAll('[data-add-label], [data-add-button], [data-add-button-sticky], [data-form-error], .form-error').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (PL[t]) el.textContent = PL[t];
    });
  }
  function watchLabels() {
    polish();
    if (!('MutationObserver' in window)) return;
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      window.requestAnimationFrame(function () { polish(); busy = false; });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchLabels); else watchLabels();
})();
